import { motion } from "framer-motion";
import { Leaf, ShieldCheck, Wrench, Ruler } from "lucide-react";
import { useShop } from "../context/ShopContext";

const icons = [Leaf, ShieldCheck, Wrench, Ruler];

const cardClasses = [
  "bg-cream-dark",
  "bg-cream",
  "bg-cream-dark",
  "bg-cream",
];

const ValueGrid = () => {
  const { t } = useShop();

  return (
    <section
      id="values"
      className="py-24 md:py-36 px-6 md:px-12 max-w-[1440px] mx-auto"
      data-testid="values-section"
    >
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="mb-14 md:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
      >
        <div>
          <p className="text-xs tracking-[0.3em] uppercase font-semibold text-olive-dark mb-4">
            {t.values.chapter}
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-brown">
            {t.values.title}
          </h2>
        </div>
        <p className="max-w-md text-base font-light leading-relaxed text-brown-light">
          {t.values.sub}
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {t.values.items.map((item, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className={`group relative border border-brown/10 p-8 overflow-hidden ${cardClasses[i]}`}
              data-testid={`value-card-${i}`}
            >
              <div className="absolute inset-0 bg-olive/0 group-hover:bg-olive/[0.06] transition-colors duration-500" />
              <div className="relative flex flex-col items-start gap-5">
                <div className="flex w-full items-start justify-between">
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-olive/40 text-olive-dark group-hover:bg-olive group-hover:text-cream group-hover:border-olive transition-colors duration-500">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <span className="font-serif text-4xl text-brown/[0.08] select-none leading-none">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-serif text-xl sm:text-2xl font-medium text-brown leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base font-light leading-relaxed text-brown-light">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default ValueGrid;
